import { render, staticRenderFns } from "./FaceHelpModal.vue?vue&type=template&id=06f5c089"
import script from "./FaceHelpModal.vue?vue&type=script&lang=js"
export * from "./FaceHelpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports